import { render, staticRenderFns } from "./ConnectedAdAccountCard.vue?vue&type=template&id=84c50b9c&scoped=true"
import script from "./ConnectedAdAccountCard.vue?vue&type=script&lang=js"
export * from "./ConnectedAdAccountCard.vue?vue&type=script&lang=js"
import style0 from "./ConnectedAdAccountCard.vue?vue&type=style&index=0&id=84c50b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c50b9c",
  null
  
)

export default component.exports